import { Link } from "react-router-dom";
import { scrollToId } from "./scroll";

export const Footer = ({ categories, locations }) => (
  <footer id="about" className="bg-navy relative grain" data-testid="main-footer">
    <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 py-20">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <div className="flex items-center gap-3">
            <span className="w-9 h-9 bg-flame flex items-center justify-center font-heading font-black text-white text-xl">P</span>
            <span className="leading-none">
              <span className="block font-heading font-black text-white text-lg tracking-tight">PRIME PRO</span>
              <span className="block text-[10px] tracking-[0.3em] text-white/60 uppercase">Connect Services</span>
            </span>
          </div>
          <p className="text-white/50 text-sm mt-6 leading-relaxed max-w-xs">
            A local service marketplace connecting homeowners with real, local
            professionals across Alabama and Tennessee.
          </p>
          <p className="text-white/30 text-xs mt-6 leading-relaxed max-w-xs">
            No fake reviews. No inflated statistics. Verification badges are only
            shown after documented confirmation.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="font-heading font-bold text-white uppercase tracking-widest text-sm mb-5">Company</p>
          <ul className="space-y-3">
            {[
              ["How It Works", "how-it-works"],
              ["Find Services", "services"],
              ["Locations", "areas"],
              ["For Professionals", "professionals"],
            ].map(([label, id]) => (
              <li key={id}>
                <button
                  data-testid={`footer-link-${id}`}
                  onClick={() => scrollToId(id)}
                  className="text-white/50 hover:text-flame text-sm transition-colors"
                >
                  {label}
                </button>
              </li>
            ))}
            <li>
              <Link to="/privacy-policy" data-testid="footer-link-privacy-policy" className="text-white/50 hover:text-flame text-sm transition-colors">
                Privacy Policy
              </Link>
            </li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="font-heading font-bold text-white uppercase tracking-widest text-sm mb-5">Services</p>
          <ul className="space-y-3">
            {categories.slice(0, 6).map((c) => (
              <li key={c.id} className="text-white/50 text-sm">{c.name}</li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="font-heading font-bold text-white uppercase tracking-widest text-sm mb-5">Service Areas</p>
          <ul className="space-y-3">
            {locations.slice(0, 6).map((l) => (
              <li key={l.id}>
                <Link
                  to={`/${l.state_slug}/${l.slug}`}
                  data-testid={`footer-area-${l.slug}`}
                  className="text-white/50 hover:text-flame text-sm transition-colors"
                >
                  {l.city}, Alabama
                </Link>
              </li>
            ))}
            <li className="text-white/30 text-sm">Tennessee — coming soon</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10 mt-16 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-white/40 text-xs">© 2026 Prime Pro Connect Services. All rights reserved.</p>
        <div className="flex items-center gap-5">
          <Link to="/privacy-policy" data-testid="footer-bottom-privacy-link" className="text-white/40 hover:text-flame text-xs transition-colors">
            Privacy Policy
          </Link>
          <p className="text-white/40 text-xs">Alabama · Tennessee</p>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
